import {
  getCurrencyUnit,
  changeCurrencyUnit,
  flatRate,
  flatRateOrigin
} from './formatMoney';
import { formatTimeStr, formatTimeStrUSA } from './formatTime';
import { limitInputFormat } from './limitNumInput';

export default function useGlobalProps(app) {
  app.config.globalProperties.$currencyUnit = getCurrencyUnit();
  app.config.globalProperties.$changeCurrencyUnit = changeCurrencyUnit(app);
  app.config.globalProperties.$formatTimeStr = formatTimeStr;
  app.config.globalProperties.$formatTimeStrUSA = formatTimeStrUSA;
  app.config.globalProperties.$flatRate = flatRate;
  app.config.globalProperties.$flatRateOrigin = flatRateOrigin;
  app.config.globalProperties.$limitInputFormat = limitInputFormat;
  app.config.globalProperties.$getShopLogo = getProductShopLogo;
  app.config.globalProperties.$getProductImg = getProductImg;
}

// 获取商品店铺图片
export function getProductShopLogo(storeSource) {
  if (storeSource === 'alibaba') {
    return require('@/assets/images/common/1688.png');
  } else if (storeSource === 'weidian') {
    return require('@/assets/images/common/weidian.png');
  } else if (storeSource === 'taobao') {
    return require('@/assets/images/common/taobao.png');
  } else if (storeSource === 'goofish') {
    return require('@/assets/images/common/xianyu.png');
  } else {
    return require('@/assets/images/common/default-shop-img.svg');
  }
}
// 获取商品图片
export function getProductImg(img) {
  return img || require('@/assets/images/common/default-good-img.svg');
}
